import React from 'react'
import classNames from 'classnames'

const ConditionalWrapper: React.FC<{
  condition: boolean
  children: React.ReactNode
  Wrapper?: React.ElementType
  wrapperClassName?: string
}> = ({ children, wrapperClassName, condition = false, Wrapper }) => {
  const Wrap = condition && Wrapper ? Wrapper : React.Fragment
  const props = condition ? { className: classNames('', wrapperClassName) } : {}
  return <Wrap {...props}>{children}</Wrap>
}

export default ConditionalWrapper
